var map = {
	"./albumdefamilia/casal.png": 7489,
	"./albumdefamilia/casal.webp": 6202,
	"./albumdefamilia/criancas.png": 7423,
	"./albumdefamilia/criancas.webp": 4909,
	"./albumdefamilia/logoalbum.png": 5630,
	"./albumdefamilia/logoalbum.webp": 2713,
	"./animals/aguia.gif": 8015,
	"./animals/aguia.webp": 6345,
	"./animals/borboleta.gif": 2346,
	"./animals/borboleta.webp": 5022,
	"./animals/cabra.gif": 4141,
	"./animals/cabra.webp": 6415,
	"./animals/cabra_estatico.png": 4602,
	"./animals/cabra_estatico.webp": 1184,
	"./animals/caranguejo.gif": 1915,
	"./animals/caranguejo.webp": 8903,
	"./animals/caranguejo_estatico.png": 4284,
	"./animals/caranguejo_estatico.webp": 8055,
	"./animals/cavalo.gif": 9016,
	"./animals/cavalo.webp": 4595,
	"./animals/cavalo_estatico.png": 8448,
	"./animals/cavalo_estatico.webp": 220,
	"./animals/crocodilo.gif": 7125,
	"./animals/crocodilo.webp": 2399,
	"./animals/crocodilo_estatico.png": 4973,
	"./animals/crocodilo_estatico.webp": 8660,
	"./animals/esquilo.gif": 9343,
	"./animals/esquilo.webp": 6622,
	"./animals/esquilo_estatico.png": 6825,
	"./animals/esquilo_estatico.webp": 5340,
	"./animals/esquilos.gif": 4799,
	"./animals/esquilos.webp": 2239,
	"./animals/esquilos_estatico.png": 6801,
	"./animals/esquilos_estatico.webp": 5503,
	"./animals/menina.gif": 1463,
	"./animals/menina.webp": 7304,
	"./animals/menina_estatico.png": 1013,
	"./animals/menina_estatico.webp": 5002,
	"./animals/mosca.gif": 9603,
	"./animals/mosca.webp": 9421,
	"./animals/ovelha.gif": 2882,
	"./animals/ovelha.webp": 4134,
	"./animals/ovelha_estatico.png": 3852,
	"./animals/ovelha_estatico.webp": 9771,
	"./animals/passaroazul.gif": 3787,
	"./animals/passaroazul.webp": 9636,
	"./animals/pato.gif": 4239,
	"./animals/pato.webp": 3911,
	"./animals/pato_estatico.png": 9213,
	"./animals/pato_estatico.webp": 9803,
	"./animals/veado.gif": 9360,
	"./animals/veado.webp": 5379,
	"./animals/veado_estatico.png": 9520,
	"./animals/veado_estatico.webp": 6369,
	"./animals/zebra.gif": 9811,
	"./animals/zebra.webp": 9997,
	"./animals/zebra_estatico.png": 9209,
	"./animals/zebra_estatico.webp": 4774,
	"./bottle/garrafa1.png": 844,
	"./bottle/garrafa1.webp": 5656,
	"./bottle/garrafa2.png": 1402,
	"./bottle/garrafa2.webp": 1397,
	"./bottle/garrafa3.png": 5756,
	"./bottle/garrafa3.webp": 4058,
	"./bottle/garrafa4.png": 758,
	"./bottle/garrafa4.webp": 1326,
	"./clouds/nuvens.png": 7547,
	"./clouds/nuvens.webp": 6547,
	"./general/circulo.png": 2387,
	"./general/circulo.webp": 4597,
	"./general/finnishline.svg": 2947,
	"./trees/arbustocrocodilo.gif": 2784,
	"./trees/arbustocrocodilo.webp": 7480,
	"./trees/arbustoesquilo.gif": 7203,
	"./trees/arbustoesquilo.webp": 6700,
	"./trees/arbustogirafa.gif": 7575,
	"./trees/arbustogirafa.webp": 4861,
	"./trees/arbustoleao.gif": 2202,
	"./trees/arbustoleao.webp": 492,
	"./trees/arbustolobo.gif": 9026,
	"./trees/arbustolobo.webp": 6351,
	"./trees/arbustomenina.gif": 3992,
	"./trees/arbustomenina.webp": 6402,
	"./trees/arbustoporco.gif": 8671,
	"./trees/arbustoporco.webp": 3530,
	"./trees/arbustorino.gif": 8619,
	"./trees/arbustorino.webp": 1997,
	"./trees/arbustotigre.gif": 7823,
	"./trees/arbustotigre.webp": 6268,
	"./trees/arbustotree.gif": 5677,
	"./trees/arbustotree.webp": 7587,
	"./trees/arbustotree2.gif": 6566,
	"./trees/arbustotree2.webp": 5553,
	"./trees/arbustourso.gif": 8997,
	"./trees/arbustourso.webp": 8025,
	"./trees/folha.svg": 3205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4579;